import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "qa-session-complete flex col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "completed verses", -1)
const _hoisted_3 = { class: "qa-sc-content grow-1 flex col" }
const _hoisted_4 = { class: "qa-sc-all-verses flex col row-md grow-1" }
const _hoisted_5 = {
  key: 0,
  class: "grow-1 flex col"
}
const _hoisted_6 = { class: "qa-sc-av-list grow-1" }
const _hoisted_7 = {
  key: 1,
  class: "grow-1 flex col"
}
const _hoisted_8 = { class: "flex row justify-space-b" }
const _hoisted_9 = { class: "qa-sc-av-list grow-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "grow-1 flex col"
}
const _hoisted_12 = { class: "qa-sc-av-list grow-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("End Session")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VerseCompleteGraph = _resolveComponent("VerseCompleteGraph")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_VerseCompleteGraph),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.correctVerses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, "correct (" + _toDisplayString(_ctx.correctVerses.length) + ")", 1),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correctVerses, (verse) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "qa-sc-av-list-item",
                    key: verse.index
                  }, _toDisplayString(_ctx.reference(verse)), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.incorrectVerses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, "incorrect (" + _toDisplayString(_ctx.incorrectVerses.length) + ")", 1),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.replaceAll(_ctx.incorrectVerses)), ["prevent"])),
                  class: "clear-btn qa-qs-skipped-button underline cursor--pointer"
                }, " replace all ")
              ]),
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incorrectVerses, (verse) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "qa-sc-av-list-item cursor--pointer qa-sc-av-incorrect",
                    key: verse.index,
                    onClick: _withModifiers(($event: any) => (_ctx.replace(verse)), ["prevent"])
                  }, _toDisplayString(_ctx.reference(verse)), 9, _hoisted_10))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.incompleteVerses.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("p", null, "incomplete (" + _toDisplayString(_ctx.incompleteVerses.length) + ")", 1),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incompleteVerses, (verse) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "qa-sc-av-list-item",
                    key: verse.index
                  }, _toDisplayString(_ctx.reference(verse)), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Button, {
      class: "margin-center",
      onClick: _withModifiers(_ctx.endSession, ["prevent"])
    }, {
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}